import "pages/Homepage/LoginBlock/LoginBlock.scss"
import Illustration from "pages/Homepage/LoginBlock/assets/workout-illustration.svg";
import Button from "components/ui/Button/Button";
import LoginDialog from "features/authentication/components/LoginDialog";
import { useDialog } from "context/DialogContext";

function LoginBlock() {
  const { showDialog } = useDialog();

  return (
    <div className={ 'login-block' }>
      <div className={ 'login-block__illustration' }>
        <img src={ Illustration } alt={ '' }/>
      </div>
      <div className={ 'login-block__text' }>
        <div>
          <div className={ 'login-block__title' }>
            <h2>Enthousiast geworden?</h2>
            <div>Log in en ga gelijk van start. Ontdek het Trefpunt!</div>
          </div>
          <Button onClick={ () => showDialog(<LoginDialog/>) } variant={ 'secondary' }>
            Inloggen
          </Button>
        </div>
      </div>
    </div>
  );
}

export default LoginBlock;
